
import React from 'react';

interface LogoProps {
  className?: string;
  showText?: boolean;
}

const Logo: React.FC<LogoProps> = ({ className = '', showText = true }) => {
  return (
    <div className={`flex items-center ${className}`}>
      <div className="relative mr-3">
        {/* Stack of coins */}
        <div className="relative">
          <div className="w-8 h-3 bg-yellow-400 rounded-full border-2 border-yellow-500 shadow-sm"></div>
          <div className="w-8 h-3 bg-yellow-400 rounded-full border-2 border-yellow-500 shadow-sm -mt-1"></div>
          <div className="w-8 h-3 bg-yellow-400 rounded-full border-2 border-yellow-500 shadow-sm -mt-1"></div>
          <div className="w-8 h-3 bg-yellow-300 rounded-full border-2 border-yellow-400 shadow-sm -mt-1"></div>
        </div>
      </div>
      {showText && (
        <div>
          <h1 className="text-2xl font-bold text-green-700">Sage Saver</h1>
          <p className="text-sm text-green-600 -mt-1">Your Savings Oracle</p>
        </div>
      )}
    </div>
  );
};

export default Logo;
